export default "__VITE_ASSET__8695243a__"